import { subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { JepWebTileLayer } from '@jeppesen-foreflight/jmkw-types';
import { Type } from '@angular/core';
import { TwcMixin } from '../../twc.mixin';

// the string in the @subclass defines what value Class.name will return. Only the string past the last '.' is returned. The others are for orgaization and unqiueness.
@subclass('jmkw.layers.TwcWebTileLayer')
export class TwcWebTileLayer extends TwcMixin<Type<JepWebTileLayer>>(
  JepWebTileLayer
) {}
